<template>
    <swiper  v-if="showSwiper&&pathType==2" :options="swiperOption" class="swiperCarrousel">
                <swiper-slide class="swiper-slide pad-0  peopleListItem" v-for="(path,i) in showCareerPath" :key="i">
                    <div ref="swiperPeoplePrompt" class="swiperPeople-prompt" v-if="path.selected || path.hoverSelect">
                        <div class="tooltip-tittle tooltip-tittleJia">
                            <!-- Monthly salary  -->
                      
                            <p class="SemiBold monthly-salary">{{$t('message.Monthly salary')}}</p>    
                            <p class="salaryRange wrap">{{$store.getters.getContent(path.salaryRange)}}</p>
                        </div>
                        <div class="tooltip-triangle">
                        </div>
                    </div>
                    <div class="swiperPeople-prompt visiHide" v-if="!path.selected && !path.hoverSelect">
                        <div class="tooltip-tittle">
                            <!-- Monthly salary  -->
                         
                        </div>
                        <div class="tooltip-triangle">
                        </div>
                    </div>
                    <div class="swiperPeopleContainer">
                        <div class="swiperPeople-pointLeft" v-if="i !== 0">
                            <div></div>
                            <div></div>
                            <div></div>
                              <div></div>
                           
                        </div>
                        <div class="swiperPeoplePlaceImg">
                        
                            <img class="swiperPeopleImg" :src=" require('@/images/ppl1.png')" alt v-if="i==0" />
                            <img class="swiperPeopleImg" :src=" require('@/images/ppl2.png')" alt v-else-if="i==(Math.ceil(showCareerPath.length/2)-1) " />
                            <img class="swiperPeopleImg" :src=" require('@/images/ppl3.png')" alt v-else-if="i==showCareerPath.length-1" />
                            <img class="swiperPeopleImg visiHide" v-else >
                            <img class="swiperPeoplePiece" ref="swiperPeoplePiece" :src="dot1" alt v-on:click="selectPath(i)" 
                            @mouseover="mouseoverSelectPath(i)" />
                           
                        </div>
                        <div class="swiperPeople-pointRigth" v-if="i !== showCareerPath.length-1">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <div class="swiperPeople-pointRigth" v-if="i == showCareerPath.length-1">
                            <div style="opacity: 0.8"></div>
                            <div style="opacity: 0.6"></div>
                            <div style="opacity: 0.4"></div>
                            <div style="opacity: 0.2"></div>
                        </div>
                    </div>
                    <div class="swiperContainer-information wrap" >
                        <p>{{$store.getters.getContent(path.title)}}</p>
                    </div>
                </swiper-slide>
    </swiper>
</template>
<script>

export default {
    data() {
        return {
            // ppl1: "",
            // ppl2: "",
            // ppl3: "",
            dot1: "",
            showCareerPath: [],
            showPiont:true,
            showSwiper:false,
            swiperOption: {
                  slidesPerView: 5,
                  spaceBetween: 5,
            }
        

        };
    },
    props: {
        careerPathThree: Array,
        pathType: 0

    },
    methods:{
        
        setWidth:function(){
             
            if(this.$store.state.innerWidth>992){
            this.showPiont = true;
            this.swiperOption = {
                slidesPerView: 5,
                spaceBetween: 5,
                
            }
            }else if(this.$store.state.innerWidth<=992){
            this.showPiont = false;
            this.swiperOption = {
                slidesPerView: 2.2,
                spaceBetween: 3,
                
            }
              
            }
            this.showSwiper = false;
            this.$nextTick(() => {
                this.showSwiper = true
            });
        }
    },
    mounted() {

        var _this = this;
         setTimeout(()=>{
            _this.setWidth();
        },1000)
        var mySwiper;
        
        var careerPathThree = this.careerPathThree
        var pathType = this.pathType
        // 
        // this.ppl1 = require("@/images/ppl1.png");
        // this.ppl2 = require("@/images/ppl2.png");
        // this.ppl3 = require("@/images/ppl3.png");
        this.dot1 = require("@/images/dot1.png");
        this.mouseoverSelectPath = function(index){
             this.showCareerPath=this.showCareerPath.map(function(v, i) {
                v.selected = false;
                if(i == index){
                    v.selected = true;
                }
                return v
            })
            
        }
        this.selectPath = function(index) {
          // 
            this.showCareerPath=this.showCareerPath.map(function(v, i) {
                if (i != index)
                    v.selected = false
                else
                    v.selected = true
                return v
            })
        }
      
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        }
    },
    watch: {
        innerwidth (news,old) {
            this.setWidth();
        },
        pathType: function(n, o) {
            // body...

            this.showCareerPath = this.careerPathThree.map(function(v, i) {
                if (i != 0)
                    v.selected = false
                else
                    v.selected = true
                return v
            })
            // 
         
             deep:true //深度监听
        }
    }
};
</script>